import { z } from "zod";

/**
 * UserType enum represents the different types of users in the MySph system.
 * - Anonymous: Represents an anonymous user who is not logged in.
 * - Subscriber: Represents a user who has a subscription to the service.
 * - Registered: Represents a user who has registered an account but does not have a subscription.
 */
export enum UserType {
  Anonymous = "y-anoy",
  Subscriber = "y-sub",
  Registered = "y-reg",
}

/**
 * UserStatus enum represents the verification status of a user in the MySph system.
 * - Verified: Represents a user whose email has been verified.
 * - NotVerified: Represents a user whose email has not been verified.
 * - UnVerified: Represents a user whose email verification status is unknown or unverified.
 * - None: Represents a user with no verification status.
 */
export enum UserStatus {
  Verified = "verified",
  NotVerified = "not_verified",
  UnVerified = "unverified",
  None = "none",
}

/**
 * Validates the user information schema used in the application.
 *
 * Supports optional login ID, email, first name, last name, visitor ID,
 * service flags, user status, and IAP linked status.
 */
export const userSchema = z.object({
  loginId: z.string().optional(),
  email: z.string().optional(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  visitorId: z.string().optional(),
  serviceFlags: z.array(z.string()).optional(),
  userStatus: z.enum(UserStatus).optional(),
  iapLinked: z.string().optional(),
});
